import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const DownloadTemplate = graphql(`
    query DownloadTemplate($filter: TemplateFilteringRule!) {
        templateFile(filter: $filter) {
            ... on TemplateDownloadSuccessfulResponse {
                result {
                    ...TemplateData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const _TemplateData = graphql(`
    fragment TemplateData on Template {
        id
        key
        version
        name
        description
        file {
            id
            url
            filename
            size
        }
        createdAt
        updatedAt
    }
`);

export const ExportPerformanceResults = graphql(`
    query ExportPerformanceResults($resultType: PerformanceResultType!, $filter: PerformanceResultFilterRule) {
        exportPerformanceResults(resultType: $resultType, filter: $filter) {
            ... on ExportPerformanceResultSuccessfulResponse {
                result {
                    downloadUrl
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export const ImportPerformanceResultMutation = graphql(`
    mutation ImportPerformanceResult($resultType: PerformanceResultType!, $file: Upload!, $size: Int!) {
        importPerformanceResult(resultType: $resultType, file: $file, size: $size) {
            ... on ImportPerformanceResultSuccessfulResponse {
                result {
                    historyId
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export const ValidateImportPerformanceResultMutation = graphql(`
    mutation ValidateImportPerformanceResult($resultType: PerformanceResultType!, $file: Upload!) {
        validateImportPerformanceResult(resultType: $resultType, file: $file) {
            ... on ValidateImportPerformanceResultSuccessfulResponse {
                result {
                    ...ValidateImportPerformanceResultData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const _ValidateImportPerformanceResultData = graphql(`
    fragment ValidateImportPerformanceResultData on ValidateImportPerformanceResult {
        updateCount
        createNewCount
        failureCount
        errors {
            field
            message
            rowNumber
        }
        totalRows
    }
`);

export const ImportHistory = graphql(`
    query ImportHistory($id: ObjectID!) {
        importHistory(id: $id) {
            ... on ImportHistory {
                id
                status
            }
        }
    }
`);

export type DownloadTemplateQuery = ResultOf<typeof DownloadTemplate>;
export type ExportPerformanceResultsQuery = ResultOf<typeof ExportPerformanceResults>;
export type ExportPerformanceResultsQueryVariables = VariablesOf<typeof ExportPerformanceResults>;
export type ImportHistoryQuery = ResultOf<typeof ImportHistory>;
